export default "__VITE_ASSET__BdJscPTe__"